module.exports = __webpack_public_path__ + "media/flags/013-russia-c2c8f8d0.svg";